<template>

<div class="main website">

	<div class="list-view no-sub-header">

		<div class="filters">

			<div :class="['filter-list-button-large', { active: showDetailTab == 'marquees' }]" @click="fetchDetailTab('marquees')">Marquees</div>
			<div :class="['filter-list-button-large', { active: showDetailTab == 'featured_products' }]" @click="fetchDetailTab('featured_products')">Featured Products</div>
			<div :class="['filter-list-button-large', { active: showDetailTab == 'department_links' }]" @click="fetchDetailTab('department_links')">Department Links</div>
			<div :class="['filter-list-button-large', { active: showDetailTab == 'featured_collections' }]" @click="fetchDetailTab('featured_collections')">Featured Collections</div>
			<div v-if="getAdministratorFlag" :class="['filter-list-button-large', { active: showDetailTab == 'category_profit' }]" @click="fetchDetailTab('category_profit')">Category Profit</div>
			<div :class="['filter-list-button-large', { active: showDetailTab == 'menus' }]" @click="fetchDetailTab('menus')">Website Menus</div>
			<div :class="['filter-list-button-large', { active: showDetailTab == 'templates' }]" @click="fetchDetailTab('templates')">Templates</div>
			<div v-if="getAdministratorFlag" :class="['filter-list-button-large', { active: showDetailTab == 'enabled' }]" @click="fetchDetailTab('enabled')">Dealers Enabled</div>

			<div v-if="!getAdministratorFlag">
				<div class="divider"></div>
				<button :class="['button', distributors.length > 0 || autoPilotEnabled ? 'action' : 'disabled']" @click="distributors.length > 0 || autoPilotEnabled ? showEnable = true : showNotEligible = true">{{ autoPilotEnabled ? 'Disable' : 'Enable' }} Auto Pilot</button>
				<div class="message pointer" @click="showAbout = true">How does it work?</div>
			</div>

		</div>

		<div class="auto-pilot detail">

			<div v-if="showDetailTab == 'marquees'">
				<loading v-if="loading" class="loading"></loading>
				<div v-else>
					<div v-if="autoPilotDetail.marquees.length == 0" class="empty-list">
						No Auto-Pilot Marquees
						<div v-if="getAdministratorFlag" class="note center" style="margin: 1em 0 0 0;">
							<router-link to="/website/marquees">Manage marquees...</router-link>
						</div>
					</div>
					<div v-else>
						<div class="sub-header">
							<div class="input-with-control">
								<input type="search" ref="search_term" v-model="filterMarqueesText" placeholder="Filter marquees..." v-focus>
							</div>
							<div v-if="getAdministratorFlag" class="controls">
								<router-link to="/website/marquees">Manage marquees <i class="fa fa-chevron-right" /></router-link>
							</div>
						</div>
						<div class="list-grid">
							<div v-for="(marquee, index) in filteredMarquees" :key="marquee.marquee_id" class="cell">
								<img v-if="marquee.image_src" :src="marquee.image_src">
								<div v-else class="no-image">No Image</div>
								<div class="title">{{ marquee.description }}</div>
								<div v-if="marquee.product_id" class="meta" style="float: right; margin: 0 1em 0 0;">Available: <span :class="{unavailable: marquee.available == 0}">{{ marquee.available }}</span></div>
								<div class="meta" style="float: left; margin: 0 1em 0 0;">Set for {{ marquee.used_on_pages }} page type{{ marquee.used_on_pages == 1 ? '' :'s' }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="showDetailTab == 'featured_products'">
				<loading v-if="loading" class="loading"></loading>
				<div v-else>
					<div v-if="autoPilotDetail.featured_products.length == 0" class="empty-list">
						No Auto-Pilot Featured Products
						<div v-if="getAdministratorFlag" class="note center" style="margin: 1em 0 0 0;">
							<router-link to="/website/featured-products">Manage featured products...</router-link>
						</div>
					</div>
					<div v-else>
						<div class="sub-header">
							<div class="input-with-control">
								<input type="search" ref="search_term" v-model="filterFeaturesText" placeholder="Filter featured products..." v-focus>
							</div>
							<div v-if="getAdministratorFlag" class="controls">
								<router-link to="/website/featured-products">Manage featured products <i class="fa fa-chevron-right" /></router-link>
							</div>
						</div>
						<div class="list-grid">
							<div v-for="(feature, index) in filteredProducts" :key="feature.feature_product_id" class="cell feature-cell">
								<div style="position: relative; text-align: center; width: 100%; height: 10em; padding: 1em 3em;">
									<img v-if="feature.image_src" :src="feature.image_src" style="width: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0; margin: auto;">
									<div v-else class="no-image">No Image</div>
								</div>
								<div class="title">{{ feature.description }}</div>
								<div class="meta">
									<div style="float: left;"><span class="label">UPC:</span> {{ feature.upc || 'N/A' }}</div>
									<div style="float: right;"><span class="label">Available:</span> <span :class="{ unavailable: feature.available < 1}">{{ feature.available || '0' }}</span></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="showDetailTab == 'department_links'">
				<loading v-if="loading" class="loading"></loading>
				<div v-else>
					<div v-if="autoPilotDetail.department_links.length == 0" class="empty-list">
						No Department Links
						<div v-if="getAdministratorFlag" class="note center" style="margin: 1em 0 0 0;">
							<router-link to="/website/department-links">Manage department links...</router-link>
						</div>
					</div>
					<div v-else>
						<div class="sub-header">
							<div class="input-with-control">
								<input type="search" ref="search_term" v-model="filterDepartmentsText" placeholder="Filter department links..." v-focus>
							</div>
							<div v-if="getAdministratorFlag" class="controls">
								<router-link to="/website/department-links">Manage department links <i class="fa fa-chevron-right" /></router-link>
							</div>
						</div>
						<div class="list-grid">
							<div v-for="(department_link, index) in filteredDepartments" class="cell">
								<div style="text-align: center;">
									<img :src="department_link.image_src">
								</div>
								<div class="title">{{ department_link.description }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="showDetailTab == 'featured_collections'">
				<loading v-if="loading" class="loading"></loading>
				<div v-else>
					<div v-if="autoPilotDetail.featured_collections.length == 0" class="empty-list">
						No Featured Collections
						<div v-if="getAdministratorFlag" class="note center" style="margin: 1em 0 0 0;">
							<router-link to="/website/featured-collections?for_auto_pilot=1">Manage featured collections...</router-link>
						</div>
					</div>
					<div v-else>
						<div class="sub-header">
							<div class="input-with-control">
								<input type="search" ref="search_term" v-model="filterCollectionsText" placeholder="Filter featured collections..." v-focus>
							</div>
							<div v-if="getAdministratorFlag" class="controls">
								<router-link to="/website/featured-collections?for_auto_pilot=1">Manage featured collections <i class="fa fa-chevron-right" /></router-link>
							</div>
						</div>
						<div class="list-grid">
							<div v-for="(featuredCollection, index) in filteredCollections" class="cell">
								<div style="text-align: center;">
									<img :src="featuredCollection.image_src">
								</div>
								<div class="title">{{ featuredCollection.description }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="showDetailTab == 'category_profit'">
				<loading v-if="loading" class="loading"></loading>
				<div v-else>
					<div v-if="autoPilotDetail.category_profit.length == 0" class="empty-list">
						No Category Profit Settings
						<div v-if="getAdministratorFlag" class="note center" style="margin: 1em 0 0 0;">
							<router-link to="/inventory/profit-margins">Manage cateogory profit...</router-link>
						</div>
					</div>
					<div v-else>
						<div class="sub-header">
							<div class="input-with-control">
								<input type="search" ref="search_term" v-model="filterCategoryProfitText" placeholder="Filter category profit..." v-focus>
							</div>
							<div v-if="getAdministratorFlag" class="controls">
								<router-link to="/inventory/profit-margins">Manage category profit <i class="fa fa-chevron-right" /></router-link>
							</div>
						</div>
						<div class="list">
						    <table class="data-list" cellpadding="0" cellspacing="0">
								<thead>
									<tr>
										<th class="list" align="left">Department</th>
										<th class="list" align="left">Category</th>
										<th class="list" align="right">Profit %</th>
										<th class="list" align="right">Low %</th>
										<th class="list" align="right">Middle %</th>
										<th class="list" align="center">Round Up</th>
									</tr>
								</thead>
								<tr v-for="(item, index) in filteredCategoryProfit" class="list-item">
									<td class="list" align="left">{{ item.department }}</td>
									<td class="list" align="left">{{ item.description }}</td>
									<td class="list" align="right">{{ item.profit_percent }}</td>
									<td class="list" align="right">{{ item.low_profit_percent }}</td>
									<td class="list" align="right">{{ item.middle_profit_percent }}</td>
									<td class="list" align="center"><i v-if="item.round_up == 1" class="fas fa-check"></i></td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>

			<div v-if="showDetailTab == 'menus'">
				<loading v-if="loading" class="loading"></loading>
				<div v-else>
					<div v-if="autoPilotDetail.menus.length == 0" class="empty-list">
						No Auto-Pilot Website Menus
						<div v-if="getAdministratorFlag" class="note center" style="margin: 1em 0 0 0;">
							<router-link to="/website/menus?for_auto_pilot=1">Manage website menus...</router-link>
						</div>
					</div>
					<div v-else>
						<div class="sub-header">
							<div class="input-with-control">
								<input type="search" ref="search_term" v-model="filterMenusText" placeholder="Filter menus..." v-focus>
							</div>
							<div v-if="getAdministratorFlag" class="controls">
								<router-link to="/website/menus?for_auto_pilot=1">Manage menus <i class="fa fa-chevron-right" /></router-link>
							</div>
						</div>
						<div v-for="(menu, index) in filteredMenus" class="four-columns" style="border-bottom: 1px dotted #999; margin: 0 0 0.5em 0; padding: 0 0 0.5em 0;">
							<div>{{ $caplitalizeWords(menu.description) }}</div>
							<div>{{ menu.menu_label }}</div>
							<div>{{ $caplitalizeWords(menu.link_type) }}</div>
							<div>{{ menu.link_value }}</div>
						</div>

					</div>
				</div>
			</div>

			<div v-if="showDetailTab == 'templates'">
				<loading v-if="loading" class="loading"></loading>
				<div v-else>
					<div v-if="autoPilotDetail.templates.length == 0" class="empty-list">
						No Auto-Pilot Templates
						<div v-if="getAdministratorFlag" class="note center" style="margin: 1em 0 0 0;">
							<router-link to="/website/template-manager">Manage templates...</router-link>
						</div>
					</div>
					<div v-else>
						<div class="sub-header">
							<div class="input-with-control">
								<input type="search" ref="search_term" v-model="filterTemplatesText" placeholder="Filter templates..." v-focus>
							</div>
							<div v-if="getAdministratorFlag" class="controls">
								<router-link to="/website/template-manager">Manage templates <i class="fa fa-chevron-right" /></router-link>
							</div>
							<div v-else class="controls">
								Select any pre-built template below for your Auto Pilot website.
							</div>
						</div>
						<div v-if="!getAdministratorFlag && publishedTemplate.template_id" style="float: right; width: 220px; margin: 0 0 0 1em; padding: 0 0 0 1em; border-left: 1px solid #ccc;">
							<h3>Published</h3>
							<template-preview-thumbnail v-if="publishedTemplate.template_type_code == 'WEBSITE_BUILDER'" :templateData="publishedTemplate.template_data"></template-preview-thumbnail>
		                    <img v-else :src="publishedTemplate.image_src">
							<div style="text-align: center; font-size: 0.9em; padding: 0.5em 0 0 0;">{{ publishedTemplate.description }}</div>
						</div>
						<h3 v-if="!getAdministratorFlag">Available Auto Pilot Templates</h3>
						<div class="list-grid" style="grid-template-columns: repeat(auto-fill, 200px);">
							<div v-for="(template, index) in filteredTemplates" :key="template.template_id" :class="['cell', getAdministratorFlag ? '' : 'clickable-list-item']" style="position: relative;" @click="showTemplateControls(index)">
								<template-preview-thumbnail :templateData="template.template_data"></template-preview-thumbnail>
								<div style="text-align: center; font-size: 0.9em; padding: 0.5em 0 0 0;">{{ template.description }}</div>
								<div v-if="selectedTemplateIndex == index" class="template-tile-controls" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(255,255,255,.5); text-align: center; padding: 50px 0 0 0;">
									<div class="button neutral" style="margin: 0 0 1em 0;" @click="previewTemplate(template)">Preview</div>
									<div class="button neutral" @click="confirmPublishTemplate(template)">Publish</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="showDetailTab == 'enabled'">
				<loading v-if="loading" class="loading"></loading>
				<div v-else class="list">
					<div v-if="enabledList.length == 0" class="empty-list">No dealers enabled</div>
					<table v-else class="data-list">
						<tr>
							<th class="list left">Dealer</th>
							<th class="list left">Address</th>
							<th class="list left">City</th>
							<th class="list left">State</th>
							<th class="list left">Zip Code</th>
						</tr>
						<tr v-for="(dealer, index) in enabledList">
							<td class="list left">{{ dealer.company_name }}</td>
							<td class="list left">{{ dealer.address_1 }}</td>
							<td class="list left">{{ dealer.city }}</td>
							<td class="list left">{{ dealer.state }}</td>
							<td class="list left">{{ dealer.zip_code }}</td>
						</tr>
					</table>
				</div>
			</div>

		</div>

	</div>

	<div v-if="showAbout" class="modal">
		<div class="inner">
			<h2>How Does It Work?</h2>
			<div class="content">
				<p>Auto Pilot is a set of top-selling products and website components managed by our in-house experts.</p>
				<p>Each marquee and featured product is selected based on current national sales data and distributor availability. Deparment Links and Featured Collections are included for a full-featured website. And the Templates are professionally designed by our graphics and web team.</p>
				<p>With Auto Pilot enabled, your website will always include the products and components your customers want.</p>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showAbout = false">Got It!</div>
			</div>
		</div>
	</div>

	<div v-if="showEnable" class="modal">
		<div class="inner">
			<h2>{{ autoPilotEnabled ? 'Disable' : 'Enable' }} Auto Pilot</h2>
			<div v-if="autoPilotEnabled" class="content">
				<p>If you disable Auto Pilot, you will need to manage your own marquees, featured products and webstie components.</p>
				<p>You can always re-enable it later if you want to again take advantage of our in-house product experts to keep your website populated with the products and components your customers want.</p>
				<p v-if="saving" style="text-align: center;">
					<b v-if="saveMessage">{{ saveMessage }}</b>
					<i v-else class="fa fa-spinner fa-spin" />
				</p>
			</div>
			<div v-else class="content">
				<p>Auto Pilot populates your website with the marquees, featured products and website components shown on this program's tabs.</p>
				<p>It will also set your website template to the one selected on the Templates tab.</p>
				<p>And best of all, marquees and featured products will be updated regularly by our in-house product experts.</p>
				<p><b>NOTE: </b>This won't delete any marquees you've uploaded yourself, but it will replace your current marquee placement settings.</p>
				<p v-if="saving" style="text-align: center;">
					<b v-if="saveMessage">{{ saveMessage }}</b>
					<i v-else class="fa fa-spinner fa-spin" />
				</p>
			</div>
			<div class="controls">
				<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="setAutoPilot()">Yes, {{ autoPilotEnabled ? 'Disable' : 'Enable' }} Auto Pilot</div>
				<div class="button cancel spaced" @click="showEnable = false">Cancel</div>
			</div>
		</div>
	</div>

	<div v-if="showConfirmPublishTemplate" class="modal">
		<div class="inner">
			<h2>Use This Template?</h2>
			<div class="content">
				<p>Are you sure you want to use <b>{{ selectedTemplate.description }}</b> as your Auto Pilot template?</p>
				<p v-if="!autoPilotEnabled">NOTE: selecting this tempalte will also enable Auto Piliot.</p>
				<p v-if="saving" style="text-align: center;">
					<b v-if="saveMessage">{{ saveMessage }}</b>
					<i v-else class="fa fa-spinner fa-spin" />
				</p>
			</div>
			<div class="controls">
				<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="publishTemplate()">Yes, use {{ selectedTemplate.description }}</div>
				<div class="button cancel spaced" @click="showConfirmPublishTemplate = false">Cancel</div>
			</div>
		</div>
	</div>

	<div v-if="showNotEligible" class="modal">
		<div class="inner">
			<h2>Not currently eligible</h2>
			<div class="content">
				<p>Auto Pilot requires either a Sports South or RSR account set up in your <router-link to="/legacy/distributorpreference.php"><b>Distributor Preferences</b></router-link>.</p>
				<p>You're welcome to browse Auto Pilot here but it will remain disabled.</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showNotEligible = false">Got It</div>
			</div>
		</div>
	</div>

	<help-popup :helpLink="{362:'Website Auto Pilot'}" :tours="false"></help-popup>

</div>

</template>

<script>
import TemplatePreviewThumbnail from '../components/TemplatePreviewThumbnail'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'clients',
	components: {
		'template-preview-thumbnail': TemplatePreviewThumbnail,
		'help-popup': HelpPopup
	},
	data() {
		return {
			loading: false,
			showDetailTab: 'marquees',
			filters: {
				page: 1,
				search_term: ''
			},
			message: '',
			distributors: [],
			showNotEligible: false,
			autoPilotDetail: {},
			filterMarqueesText: '',
			filterFeaturesText: '',
			filterDepartmentsText: '',
			filterCollectionsText: '',
			filterCategoryProfitText: '',
			filterTemplatesText: '',
			filterMenusText: '',
			menuItemsList: [],
			publishedTemplate: {},
			showAbout: false,
			autoPilotEnabled: false,
			showEnable: false,
			saving: false,
			saveMessage: '',
			selectedTemplateIndex: -1,
			selectedTemplate: {},
			showConfirmPublishTemplate: false,
			enabledList: []
		}
	},
	created() {
		if (!this.getAdministratorFlag) {
			this.fetchPreference()
			this.fetchDistributors()
		}
		this.resetAutoPilot()
		this.fetchDetailTab(this.showDetailTab, true)
	},
	computed: {
		hasFilters() {
			for (const [key, value] of Object.entries(this.filters)) {
				if (['search_term'].includes(key) && value) {
					return true
				}
			}
			return false
		},
		filteredMarquees() {
			let filteredList = this.autoPilotDetail.marquees.filter(item => {
				return this.filterMarqueesText == '' || item.description.toLowerCase().indexOf(this.filterMarqueesText.toLowerCase()) > -1
			})
			return filteredList
		},
		filteredProducts() {
			let filteredList = this.autoPilotDetail.featured_products.filter(item => {
				return this.filterFeaturesText == '' || item.description.toLowerCase().indexOf(this.filterFeaturesText.toLowerCase()) > -1
			})
			return filteredList
		},
		filteredDepartments() {
			let filteredList = this.autoPilotDetail.department_links.filter(item => {
				return this.filterDepartmentsText == '' || item.description.toLowerCase().indexOf(this.filterDepartmentsText.toLowerCase()) > -1
			})
			return filteredList
		},
		filteredCollections() {
			let filteredList = this.autoPilotDetail.featured_collections.filter(item => {
				return this.filterCollectionsText == '' || item.description.toLowerCase().indexOf(this.filterCollectionsText.toLowerCase()) > -1
			})
			return filteredList
		},
		filteredCategoryProfit() {
			let filteredList = this.autoPilotDetail.category_profit.filter(item => {
				return this.filterCategoryProfitText == '' || item.description.toLowerCase().indexOf(this.filterCategoryProfitText.toLowerCase()) > -1
			})
			return filteredList
		},
		filteredMenus() {
			let filteredList = this.menuItemsList.filter(item => {
				return this.filterMenusText == '' || (item.menu_label + item.link_value).toLowerCase().indexOf(this.filterMenusText.toLowerCase()) > -1
			})
			return filteredList
		},
		filteredTemplates() {
			let filteredList = this.autoPilotDetail.templates.filter(item => {
				return this.filterTemplatesText == '' || item.description.toLowerCase().indexOf(this.filterTemplatesText.toLowerCase()) > -1
			})
			return filteredList
		}
	},
	methods: {
		resetAutoPilot() {
			this.autoPilotDetail = {
				marquees: [],
				featured_products: [],
				department_links: [],
				featured_collections: [],
				category_profit: [],
				templates: [],
				menus: [],
				dealers_enabled: []
			}
		},
		fetchPreference() {
			this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'ENABLE_AUTO_PILOT' } }).then(obj => {
				this.autoPilotEnabled = obj.ENABLE_AUTO_PILOT
			}).catch(err => {
				console.log(err)
			})
		},
		fetchDistributors() {
			this.apiCall({ destination: 'get_list_client_distributors', data: { auto_pilot: true } }).then(obj => {
				this.distributors = obj.client_distributors
				//this.showNotEligible = true
			}).catch(err => {
				console.log(err)
			})
		},
		fetchDetailTab(detailTab, forceReload = false) {
			this.showDetailTab = detailTab
			// skip API call if this section already populated
			//if (!forceReload && this.autoPilotDetail[detailTab] && this.autoPilotDetail[detailTab].length > 0) { return }
			this.loading = true
			switch (detailTab) {
				case 'marquees':
					this.apiCall({ destination: 'get_list_marquees', data: { get_full_list: true, auto_pilot: true } }).then(obj => {
						this.loading = false
						this.autoPilotDetail.marquees = obj.marquees
					}).catch(err => {
						console.log(err)
					})
					break
				case 'featured_products':
					this.apiCall({ destination: 'get_list_feature_products', data: { auto_pilot: true } }).then(obj => {
						this.loading = false
						this.autoPilotDetail.featured_products = obj.features
					}).catch(err => {
						console.log(err)
					})
					break
				case 'department_links':
					this.apiCall({ destination: 'get_list_department_links', data: { published: true, auto_pilot: true } }).then(obj => {
						this.loading = false
						this.autoPilotDetail.department_links = obj.department_links
					}).catch(err => {
						console.log(err)
					})
					break
				case 'featured_collections':
					this.apiCall({ destination: 'get_list_featured_collections', data: { published: true, auto_pilot: true } }).then(obj => {
						this.loading = false
						this.autoPilotDetail.featured_collections = obj.featured_collections
					}).catch(err => {
						console.log(err)
					})
					break
				case 'category_profit':
					this.apiCall({ destination: 'get_list_category_profit', data: { get_full_list: true, auto_pilot: true } }).then(obj => {
						this.loading = false
						this.autoPilotDetail.category_profit = obj.list
					}).catch(err => {
						console.log(err)
					})
					break
				case 'templates':
					this.apiCall({ destination: 'get_list_system_templates', data: { auto_pilot: true } }).then(obj => {
						this.loading = false
						this.autoPilotDetail.templates = obj.templates
						if (obj.published_template) {
							this.publishedTemplate = obj.published_template
						}
					}).catch(err => {
						console.log(err)
					})
					break;
				case 'menus':
					this.apiCall({ destination: 'get_list_menus', data: { menu_code: 'DEALER_WEBSITE_MENUS', auto_pilot: true } }).then(obj => {
						if (obj.menus) {
							this.autoPilotDetail.menus = obj.menus
							this.menuItemsList = []
							this.autoPilotDetail.menus.forEach(menu => {
								this.apiCall({ destination: 'get_list_menu_items', data: { menu_code: menu.menu_code, auto_pilot: true } }).then(obj => {
									menu.menu_items = []
									obj.menu_items.forEach(menuItem => {
										menuItem.description = menu.description
										this.menuItemsList.push(menuItem)
									})
									if (menu.menu_code == this.autoPilotDetail.menus[this.autoPilotDetail.menus.length - 1]['menu_code']) {
            							setTimeout(() => { this.loading = false }, 100) // allow object to fully populate
									}
								}).catch(err => {
									console.log(err)
								})
							})
						} else {
							this.message = obj.message
						}
					}).catch(err => {
						console.log(err)
					})
					break
				case 'enabled':
					this.apiCall({ destination: 'get_list_auto_pilot_enabled' }).then(obj => {
						this.loading = false
						this.enabledList = obj.list
					}).catch(err => {
						console.log(err)
					})
					break;
				default:
					this.loading = false
					break
			}
		},
		setAutoPilot() {
			if (this.saving || this.getAdministratorFlag) { return }
			if (this.distributors.length == 0 && !this.autoPilotEnabled) { return }
			this.saveMessage = ''
			this.saving = true
			this.apiCall({ destination: 'save_item_enable_auto_pilot', data: { auto_pilot: true } }).then(obj => {
				if (obj.status == 'success') {
					if (this.autoPilotEnabled) {
						this.saveMessage = "Auto Pilot has been disabled for your website."
					} else {
						this.saveMessage = "Auto Pilot has been enabled for your website!"
					}
				} else {
					this.saveMessage = obj.message
				}
            	setTimeout(() => {
					this.saving = false
					this.showEnable = false
					this.saveMessage = ''
					this.autoPilotEnabled = !this.autoPilotEnabled
					if (obj.template_reset && this.showDetailTab == 'templates') {
						this.fetchDetailTab('templates', true)
					}
				}, 3000)
			}).catch(err => {
				console.log(err)
			})
		},
		showTemplateControls(index) {
			if (this.getAdministratorFlag || this.distributors.length == 0) { return }
			if (this.selectedTemplateIndex == index) {
				this.selectedTemplateIndex = -1
			} else {
				this.selectedTemplateIndex = index
			}
		},
		previewTemplate(template) {
			let previewURL
			if (window.location.hostname.indexOf('.test') > -1) {
				previewURL = 'https://cdsfrontend.test:8081/frontend/?template_id=' + template.template_id
			} else {
				previewURL = window.location.origin + '/' + "?template_id=" + template.template_id
			}
			var previewWindow = window.open(previewURL, "_blank")
		},
		confirmPublishTemplate(template) {
			if (this.getAdministratorFlag) { return }
			this.selectedTemplate = template
			this.showConfirmPublishTemplate = true
		},
		publishTemplate() {
			if (this.saving || this.getAdministratorFlag) { return }
			if (this.distributors.length == 0) { return }
			this.selectedTemplateIndex = -1
			this.saving = true
			this.apiCall({ destination: 'publish_item_template', data: { template_id: this.selectedTemplate.template_id } }).then(obj => {
				if (obj.status == 'success') {
					this.saveMessage = "Auto Pilot template has been updated!."
				} else {
					this.saveMessage = obj.message
				}
            	setTimeout(() => {
					this.saving = false
					this.showConfirmPublishTemplate = false
					this.saveMessage = ''
					this.fetchDetailTab('templates', true)
				}, 3000)
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
